import {useTheme, SvgIcon} from '@mui/material';
import MainLinearGradient from '@icons/MainLinearGradient';

export default function ArrowHomeIcon() {
	const theme = useTheme();
	// @ts-ignore
	const color = theme.palette.mode === 'light' ? theme.palette.primary[400] : theme.palette.primary[50];
	return (
		<svg className="ltr:-scale-100" width="29" height="28" viewBox="0 0 29 28" fill="none">
			<path
				d="M26.2731 8.68011L17.5398 1.69344C15.8331 0.333439 13.1665 0.320106 11.4731 1.68011L2.73979 8.68011C1.48645 9.68011 0.726454 11.6801 0.993121 13.2534L2.67312 23.3068C3.05979 25.5601 5.15312 27.3334 7.43312 27.3334H21.5665C23.8198 27.3334 25.9531 25.5201 26.3398 23.2934L28.0198 13.2401C28.2598 11.6801 27.4998 9.68011 26.2731 8.68011ZM15.4998 22.0001C15.4998 22.5468 15.0465 23.0001 14.4998 23.0001C13.9531 23.0001 13.4998 22.5468 13.4998 22.0001V18.0001C13.4998 17.4534 13.9531 17.0001 14.4998 17.0001C15.0465 17.0001 15.4998 17.4534 15.4998 18.0001V22.0001Z"
				fill={color}/>
		</svg>
	);
}
